import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ProductProvider } from './ProductContext'; // Adjust to './context/ProductContext' if needed
import Home from './pages/Home';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import About from './pages/About';
import Register from './pages/Register';
import Reg from './pages/Reg';
import Buy from './pages/Buy';
import Sold from './pages/Sold';
import Error from './pages/Error';
import ProductDetails from './pages/ProductDetails';

function App() {
  return (
    <div className="App">
      <ProductProvider>
        <BrowserRouter>
          <Routes>
            <Route index element={<Home />} />
            <Route path="/Home" element={<Home />} />
            <Route path="/Contact" element={<Contact />} />
            <Route path="/Privacy" element={<Privacy />} />
            <Route path="/Terms" element={<Terms />} />
            <Route path="/About" element={<About />} />
            <Route path="/Register" element={<Register />} />
            <Route path="/Reg" element={<Reg />} />
            <Route path="/Buy" element={<Buy />} />
            <Route path="/Sold" element={<Sold />} />
            <Route path="/Error" element={<Error />} />
            <Route path="/product/:productId" element={<ProductDetails />} />
            <Route path="*" element={<Error />} />
          </Routes>
        </BrowserRouter>
      </ProductProvider>
    </div>
  );
}

export default App;